import styled from '@emotion/styled';

import COLOR from '../../../shared/constant/colorset';
import { isPC } from '../../../../util/window/getDevice';
import { EventBenefitResponse } from '../../../shared/interfaces';
import applyImageUrlFormat
  from '../../../shared/utils/image/imaegUrlformatter';

const EventList = styled.ul`
  width: ${isPC ? '1050px' : '100%'};
  margin:0 auto;
  padding-top: ${isPC ? 0 : '44px'};
`;

const Item = styled.li`
  margin-bottom: 10px;
  background-color: ${COLOR.bg};
`;

const EventLink = styled.div`
  display: block;
  cursor: pointer;
`;

const Img = styled.img`
  display: block;
  width: 100%;
  height: ${isPC ? '200px' : '37.5vw'};
  object-fit: cover;
`;

interface Props {
  eventList: EventBenefitResponse[];
  onClickBanner(link: string | null, giftIds: string | null, index: number): void;
}

export default function EventBenefit({
  eventList,
  onClickBanner,
}: Props) {
  return (
    <EventList>
      {eventList.map(({ id, title, link, mobileLink, image, mobileImage, giftIds }, index) => (
        <Item key={id}>
          <EventLink
            onClick={() => onClickBanner(isPC ? link : mobileLink, giftIds, index)}
          >
            <Img
              src={applyImageUrlFormat(isPC ? image : mobileImage,
                { width: isPC ? 1050 : 750,
                  format: 'auto',
                })}
              alt={title}
            />
          </EventLink>
        </Item>
      ))}
    </EventList>
  );
}
